/** Matches api-medpharma RegistrationPlatform for users signing up via the doctor marketing website. */
export const REGISTRATION_PLATFORM_DOCTOR_WEBSITE = "doctor-website" as const;
